<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          <b-row>
            <b-col cols="6">
              <span>Feedback Details</span>
            </b-col>
           
            <b-col  cols='6' class="text-right">
              <b-button variant="link"  @click="previous()">  <i
                v-if="previousIcon"
                class="fa fa-chevron-left pr-4"
                style="color: blue"
               
                aria-hidden="true"
              ></i></b-button>
            <b-button variant="link" @click="next()">  <i
                v-if="nextIcon"
                class="fa fa-chevron-right"
                style="color: blue"
                @click="next()"
                aria-hidden="true"
              ></i></b-button>
            </b-col>
          </b-row>
        </template>
        <!-- <b-container v-if="feedback"> -->
        <div v-if="feedback">
          <b-row>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="12">
                  <span class="item_title" style="font-size:18px">Subject</span>
                </b-col>
                <b-col cols="12">
                  <span class="item_title" style="font-size:14px">{{feedback.subject}}</span>
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col cols="12">
                  <span class="item_title" style="font-size:18px">Body</span>
                </b-col>
                <b-col cols="12">
                  <span class="item_title" style="font-size:14px">{{feedback.body}}</span>
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col cols="12">
                  <span class="item_title" style="font-size:18px">Status</span>
                </b-col>
                <b-col cols="12">
                  <span class="item_title" style="font-size:14px">{{feedback.status}}</span>
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col cols="12">
                  <span class="item_title" style="font-size:18px">Images</span>
                </b-col>
                <!-- <b-col cols="12" md="3" v-for="(item,i) in photos" :key="i" align="center" class="py-2">
                 
              <img v-bind:src="baseURL+'/u/'+item.photo" width="100%" height="100%"  v-b-modal.modal-lg  @click="openImg(item)" />
             
            </b-col>
             <showImage v-if="showImg" v-bind:storage="imgModal"  @stepper="winStepper"/> -->
              
             <div class="card-body text-secondary">
              <div
                v-if="photos != null && photos.length > 0"
                style="
                  overflow-x: auto !important;
                  overflow-y: hidden !important;
                "
              >
                <div v-viewer style="display: flex">
                  <div
                    v-for="image in photos"
                    :key="image.key"
                    style="width: 100%; max-height: 200px"
                    class="col-md-3"
                  >
                    <img
                      :src="baseURL + '/u/' + image.photo"
                      class="image"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        max-width: 250px;
                      "
                      :key="image.src"
                    />
                  </div>
                </div>
              </div>
            </div>
              </b-row>
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="12">
                  <span class="item_title" style="font-size:18px">Created On</span>
                </b-col>
                <b-col cols="12">
                  <span
                    class="item_title"
                    style="font-size:14px"
                  >{{formatDate(feedback.createddate)}}</span>
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col cols="12">
                  <span class="item_title" style="font-size:18px">Email</span>
                </b-col>
                <b-col cols="12">
                  <span class="item_title" style="font-size:14px">{{feedback.email}}</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12" class="py-2">
              <span class="item_title" style="font-size:18px">Added By</span>
            </b-col>
            <b-col v-if="user.photo" cols="12" class="py-2">
              <img :src="baseURL+'/u/'+user.photo" height="100px" />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Name</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.name}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.phonePrefix}}&nbsp;{{user.phone}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Age</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.age}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Occupation</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.occupation}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Country</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.country}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Phone Verified</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.isPhoneVerified}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">Gender</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.gender}}</span>
                </b-col>
              </b-row>
              <hr />
              <b-row>
                <b-col cols="5">
                  <span class="item_title">User ID</span>
                </b-col>
                <b-col cols="7">
                  <span class="item_value">{{user.userid}}</span>
                </b-col>
              </b-row>
              <hr />
            </b-col>
          </b-row>
          <b-row v-if="superAdmin" class="justify-content-center">
            <div class="px-2">
              <b-button
                v-if="feedback.status=='New'"
                variant="outline-danger"
                @click="markStatus('Read')"
                size="sm"
              >Mark as Read</b-button>
              <b-button
                v-else-if="feedback.status=='Read'"
                variant="outline-primary"
                @click="markStatus('New')"
                size="sm"
              >Mark as New</b-button>
            </div>
            <div class="px-2">
              <b-button variant="outline-danger" @click="confirmBox" size="sm">Remove</b-button>
            </div>
          </b-row>
        </div>
        <!-- </b-container> -->
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import showImage from "../Incidents/ImageViewer";
export default {
  components: {
    
    showImage
  },
  props: ["id1", "idset"],
  data() {
    return {
      previousIcon: true,
      nextIcon: true,
      feedback: null,
      user: null,
      photos: [],
      appLoading: false,
      id: null,
      map: null,
      oMarker: [],
      ServerError: false,
      superAdmin: false,
      showImg: false,
      imgModal: {},
    };
  },
  beforeMount() {
    if (localStorage.getItem("role") != "Sub Admin") this.superAdmin = true;
    this.getData();
  },
  methods: {
      winStepper(window_data) {
      this.showImg=window_data.showImg
    //  this.winStep = window_data.winStep;
   },
   next() {
      // alert(this.id,this.idset)
      var temp = [];
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          this.$router.push("/Feedbacks/" + temp[j + 1] + "/" + temp);
          this.getData();
        }
      }
    },
    previous() {
      var temp = [];
      // console.log("hiil", this.idset);
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          if (j != 0) {
            this.$router.push("/Feedbacks/" + temp[j - 1] + "/" + temp);
            this.getData();
          }
        }
      }
    },
   openImg(item) {
      this.showImg = true;
      this.imgModal = item;
      // console.log(item);
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/feedback/get",
        params: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.feedback = response.data.data;
          var img = {}
          for(var i=0;i<response.data.data.image.length;i++){
          img.photo =  response.data.data.image[i]
          this.photos.push(img);
          }
          // console.log(this.photos)
          this.id = this.feedback._id;
          this.user = this.feedback.user;
          var temp = [];
          temp = this.idset.split(",");
          if (this.id == temp[0]) {
            this.previousIcon = false;
          } else this.previousIcon = true;
          if (this.id == temp[temp.length - 1]) {
            this.nextIcon = false;
          } else this.nextIcon = true;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    confirmBox() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to remove this Feedback.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.removeFeedback();
          }
        })
        .catch(err => {
          this.ServerError = true;
        });
    },
    markStatus(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/feedback/status",
        data: {
          id: this.$route.params.id,
          status: item
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.getData();
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    removeFeedback() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/feedback/remove",
        data: {
          id: this.$route.params.id
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch(e => {
          this.ServerError = true;
        });
    }
  }
};
</script>